<template>
  <div style="height: 100%">
    <BigScreen
      id="bigScreen"
      :bigScreenFlag="bigScreenFlag"
      v-on:exitBigScreen="exitBigScreen"
    ></BigScreen>
    <el-container v-show="!bigScreenFlag" class="bodyContainerClass">
      <el-header class="headerStyle">
        <div>
          <p
            style="
              font-size: 1em;
              float: left;
              position: relative;
              margin: 0;
              line-height: 40px;
            "
          >
            <span v-text="this.$custormConfig.systemTitle"></span>
          </p>
        </div>
        <!-- 右边 个人中心 下拉列表 -->
        <el-dropdown
          style="float: right; color: white; line-height: 40px; cursor: pointer"
          placement="bottom-start"
          size="small"
        >
          <span class="el-dropdown-link">
            {{ loginUser }}
            <i class="el-icon-arrow-down"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="self">个人中心</el-dropdown-item>
            <el-dropdown-item @click.native="logOut">退出</el-dropdown-item>
            <el-dropdown-item @click.native="handleTestInternetSpeed"
              >测试网络速度</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <!-- 大屏 -->
        <!-- <div
          @click="enterBigScreen"
          style="
            float: right;
            color: white;
            line-height: 40px;
            cursor: pointer;
            margin-right: 20px;
            font-size: 18px;
          "
        >
          <span class="icon iconfont">&#xe615;</span>
        </div> -->
        <!-- 登录园区 -->
      </el-header>

      <el-container style="height: calc(100% - 40px)">
        <el-aside class="asideStyle">
          <div style="margin: 0px" class="toggleBtns">
            <transition name="fade">
              <div class="toggleBtnsTitle" v-show="!isCollapse">系统菜单</div>
            </transition>
            <div title="折叠菜单" class="toggleBtnsSwitch" @click="fold">
              <i class="iconfont">&#xe872;</i>
            </div>
          </div>
          <el-scrollbar style="height: calc(100% - 30px)">
            <el-menu
              class="el-menu-vertical-demo"
              @open="handleOpen"
              @close="handleClose"
              :collapse="isCollapse"
              :unique-opened="true"
              :router="true"
              :default-active="$route.path"
            >
              <el-submenu
                v-for="(parent, parentIndex) in menuData"
                :key="parentIndex"
                :index="parentIndex + ''"
              >
                <template slot="title">
                  <i :class="parent.iconClass"></i>
                  <span slot="title">{{ parent.name }}</span>
                </template>
                <el-menu-item
                  v-for="(child, childIndex) in parent.children"
                  :key="childIndex"
                  :index="child.uri + ''"
                  @click="menuClick(child.name)"
                  >{{ child.name }}
                </el-menu-item>
              </el-submenu>
            </el-menu>
          </el-scrollbar>
        </el-aside>

        <el-main class="mainClass">
          <el-tabs
            v-model="activeTab"
            type="card"
            style="height: 100% !important"
            @tab-remove="removeTab"
            @tab-click="tabClick"
            id="mainTabs"
          >
            <el-tab-pane
              v-for="item in tabsItem"
              :key="item.name"
              :label="item.title"
              :name="item.name"
              :closable="item.closable"
              :ref="item.ref"
              style="height: 100% !important"
            >
              <span slot="label" class="mainTabsTitle">{{ item.title }} </span>
              <component :is="item.content"></component>
            </el-tab-pane>
          </el-tabs>

          <!-- 右键 关闭全部 标签卡菜单 -->
          <div v-show="contextMenuVisible">
            <ul
              :style="{ left: menuLeft + 'px', top: menuTop + 'px' }"
              class="contextmenu"
            >
              <li>
                <span type="text" @click="closeAll()" size="mini"
                  >关闭所有</span
                >
              </li>
            </ul>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<style scoped lang="scss">
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.bodyContainerClass {
  overflow: hidden;
  height: 100%;
}
.headerStyle {
  top: 0;
  background-color: var(--headColor);
  height: 40px !important;
  color: var(--whiteColor);
  border-bottom: 1px solid var(--borderColor);
}
.mainClass {
  margin: 0px;
  padding: 0px;
  overflow: hidden;
}
.asideStyle {
  width: fit-content !important;
  overflow: hidden;
  background-color: var(--asideColor);
}
/deep/ .el-tabs__content {
  height: calc(100% - 50px);
  overflow: auto;
  padding-top: 15px;
}

.mainTabsTitle {
  background-color: var(--grayBg);
  padding: 0;
  border: 1px solid #eee;
  padding: 5px 15px;
}
.mainTabsTitle:hover {
  background-color: var(--tabActiveBg);
  color: var(--whiteColor);
}
// /deep/ .el-tabs__item.is-active,.el-tabs__item:hover {
//   color: var(--menuActiveText);
// }
/deep/ .el-menu {
  background-color: var(--asideColor) !important;
  border: none;
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
  }
  .el-submenu__title {
    color: var(--primaryColor);
    i {
      color: var(--primaryColor);
    }
    &:hover {
      background: var(--menuHoverBg);
      color: var(--menuActiveText);
    }
  }
  .el-menu-item {
    color: var(--primaryColor);

    &:hover {
      background: var(--menuHoverBg);
      color: var(--menuActiveText);
    }
  }
  .el-menu-item.is-active {
    background: var(--menuHoverBg);
    color: var(--menuActiveText);
  }
}
.toggleBtns {
  color: var(--primaryColor);
  position: relative;
  font-size: 1.1rem;
  height: 32px;
  line-height: 32px;
  transition: width 0.3s ease;
  .fade-enter-active {
    transition: opacity 0.8s ease-in;
  }
  .fade-leave-active {
    transition: opacity 0.3s ease-in;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .toggleBtnsTitle {
    font-size: 14px;
    width: 64px;
    text-align: center;
    font-weight: bold;
  }
  .toggleBtnsSwitch {
    position: absolute;
    top: 0;
    right: 0;
    width: 64px;
    cursor: pointer;
    text-align: center;
    &:hover {
      color: var(--menuActiveText);
    }
  }
}
.contextmenu {
  width: 100px;
  margin: 0;
  border: 1px solid #ccc;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.2);
}
.contextmenu li {
  margin: 0;
  padding: 3px 18px;
}
.contextmenu li:hover {
  background: #f2f2f2;
  cursor: pointer;
}
.contextmenu li span {
  color: #2c3e50;
}
/deep/ .el-scrollbar__wrap {
  overflow: scroll;
  overflow-x: auto;
}
/deep/ .el-scrollbar__view {
  height: 100%;
}
</style>

<script>
import BigScreen from './BigScreen';
import {
  fullScreen,
  exitScreen,
  getLoginUser,
  removeToken,
  removeLoginGarden,
  removeLoginUser,
} from '../untils/func';
import HomePage from './HomePage';
import { getUserPermission, exit } from '../api/system/basicUser';
import { testInternetSpeed } from '../api/system/systemTools';
import { selectDicValueByDicKey } from '../api/system/systemCustomConfig';
import systemConstant from '../constant/systemConstant';

export default {
  components: { BigScreen },
  comments: { BigScreen },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      menuData: [],
      menuName: '',
      loginUser: '',
      tabName: '',

      fullSize: {
        width: '100%',
        height: '100%',
      },

      isCollapse: false,
      // menuItemStyle:{height:'30px'},
      newDate: new Date(),
      bigScreenFlag: false,

      activeTab: '1', //默认显示的tab
      tabIndex: 1, //tab目前显示数
      tabsItem: [],
      tabsPath: [
        {
          name: '1',
          path: 'homePage',
        },
      ],
      contextMenuVisible: false, //右键关闭显/隐藏
      menuLeft: 0,
      menuTop: 0,
    };
  },

  watch: {
    screenWidth(newVal) {
      if (newVal < 1200) {
        this.isCollapse = true;
      }
    },
    bigScreenFlag(newFlag) {
      // console.log(newFlag)
      this.$root.bigScreenVisible = newFlag;
    },
    $route: function (to) {
      //监听路由的变化，动态生成tabs
      let flag = true; //判断是否需要新增页面
      let path = to.path;
      console.log(path);
      if (path.indexOf('/') != -1) {
        path = path.substring(path.lastIndexOf('/') + 1, path.length);
      }
      this.tabName = path;
      if (Object.keys(to.meta).length != 0) {
        for (let i = 0; i < this.$refs.tabs.length; i++) {
          if (i != 0) {
            //首页不判断 如果页面已存在，则直接定位当页面，否则新增tab页面
            if (
              path.indexOf('roleModule') != -1 ||
              path.indexOf('userModule') != -1 ||
              path.indexOf('openAccount') != -1 ||
              path.indexOf('addSellElctric') != -1 ||
              path.indexOf('cancelSellElectric') != -1 ||
              path.indexOf('addSellWater') != -1 ||
              path.indexOf('cancelSellWater') != -1 ||
              path.indexOf('printView') != -1
            ) {
              if (this.$refs.tabs[i].label == to.meta.name) {
                this.activeTab = this.$refs.tabs[i].name; //定位到已打开页面
                // this.tabClick();
                flag = false;
                break;
              }
            } else {
              if (this.$refs.tabs[i].label == this.menuName) {
                this.activeTab = this.$refs.tabs[i].name; //定位到已打开页面
                flag = false;
                break;
              }
            }
          }
        }
        //新增页面
        if (flag) {
          //获得路由元数据的name和组件名
          let thisName = this.menuName;
          if (
            path.indexOf('roleModule') != -1 ||
            path.indexOf('userModule') != -1 ||
            path.indexOf('openAccount') != -1 ||
            path.indexOf('addSellElctric') != -1 ||
            path.indexOf('cancelSellElectric') != -1 ||
            path.indexOf('addSellWater') != -1 ||
            path.indexOf('cancelSellWater') != -1 ||
            path.indexOf('printView') != -1
          ) {
            thisName = to.meta.name;
          }

          const thisComp = to.meta.comp;
          //对tabs的当前激活下标和tabs数量进行自加
          let newActiveIndex = ++this.tabIndex + '';
          //动态双向追加tabs
          this.tabsItem.push({
            title: thisName,
            name: String(newActiveIndex),
            closable: true,
            ref: 'tabs',
            content: thisComp,
          });
          this.activeTab = newActiveIndex;
          /*
           * 当添加tabs的时候，把当前tabs的name作为key，path作为value存入tabsPath数组中
           * key:tabs的name
           * value:tabs的path
           * {
           *   key: name,
           *   value: path
           * }
           * ///后面需要得到当前tabs的时候可以通过当前tabs的name获得path
           * */
          if (this.tabsPath.indexOf(path) == -1) {
            this.tabsPath.push({
              name: newActiveIndex,
              path: path,
            });
          }
        }
      }
    },
    tabName(newVal) {
      // alert(newVal)
      if (newVal == 'homePage') {
        this.$root.tabName = 'homePage';
      }
      if (newVal == 'electric') {
        this.$root.tabName = 'electric';
      }
    },
    contextMenuVisible() {
      //监听 右键关闭菜单 点击任何地方 菜单消失
      if (this.contextMenuVisible) {
        document.body.addEventListener('click', this.closeMenu);
      } else {
        document.body.removeEventListener('click', this.closeMenu);
      }
    },
  },

  created() {
    this.init();
  },

  methods: {
    async init() {
      this.loginUser = getLoginUser();
      const response = await getUserPermission().then();
      this.menuData = response.data;
      this.tabsItem = [
        {
          title: '首页',
          name: '1',
          closable: false,
          ref: 'tabs',
          content: HomePage,
        },
      ];

      await this.getServiceFeeName();
    },

    //获取服务费自定义名称
    async getServiceFeeName() {
      const res = await selectDicValueByDicKey(
              systemConstant.PRICE_ELECTRIC_SERVICE_FEE_NAME
      ).then();
      this.$root.serviceFeeNameElectric = res.data;

      const res2 = await selectDicValueByDicKey(
              systemConstant.PRICE_WATER_SERVICE_FEE_NAME
      ).then();
      this.$root.serviceFeeNameWater = res2.data;

    },

    async getSystemTitle() {
      const res = await selectDicValueByDicKey(
        systemConstant.SYSTEM_TITLE
      ).then();
      console.log(res);
    },

    handleTestInternetSpeed() {
      const param = {
        timeStamp: new Date().getTime(),
      };
      testInternetSpeed(param).then((response) => {
        this.msgSuccess(response.data);
      });
    },

    menuClick(menuName) {
      this.menuName = menuName;
    },

    removeTab(targetName) {
      //删除Tab
      let tabs = this.tabsItem; //当前显示的tab数组
      let activeName = this.activeTab; //点前活跃的tab

      //如果当前tab正活跃 被删除时执行
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
              this.tabClick(nextTab);
            }
          }
        });
      }
      this.activeTab = activeName;
      this.tabsItem = tabs.filter((tab) => tab.name !== targetName);
      //在tabsPath中删除当前被删除tab的path
      this.tabsPath = this.tabsPath.filter((item) => item.name !== targetName);
    },
    tabClick(thisTab) {
      /*
       * thisTab:当前选中的tabs的实例
       * 通过当前选中tabs的实例获得当前实例的path 重新定位路由
       * */
      this.menuName = thisTab.title || thisTab.label;
      // alert(this.menuName)

      let val = this.tabsPath.filter((item) => thisTab.name == item.name);
      this.tabName = val[0].path;
      if (this.tabName.indexOf('/') != -1) {
        this.tabName = this.tabName.substring(
          this.tabName.lastIndexOf('/') + 1,
          this.tabName.length
        );
      }
      // console.log(this.tabName)
      this.$router.push({
        path: val[0].path,
      });
    },

    closeAll() {
      // 关闭所有标签卡
      this.tabsItem = [
        {
          title: '首页',
          name: '1',
          closable: false,
          ref: 'tabs',
          content: HomePage,
        },
      ];

      this.tabsPath = [
        {
          name: '1',
          path: 'homePage',
        },
      ];

      this.activeTab = '1';
      this.tabIndex = 1;

      this.closeMenu();
      const location = String(window.location);
      window.location =
        location.substring(
          0,
          location.indexOf('mainWindow') + 'mainWindow'.length
        ) + '/homePage';
      this.tabName = 'homePage';
    },

    openContextMenu(e) {
      // 打开关闭所有菜单
      e.preventDefault(); //防止默认菜单弹出

      this.contextMenuVisible = true;
      this.menuLeft = e.clientX;
      this.menuTop = e.clientY + 20;
    },
    closeMenu() {
      //关闭菜单
      this.contextMenuVisible = false;
    },

    exitBigScreen() {
      this.bigScreenFlag = false;
      document.getElementById('bigScreen').style.visibility = 'hidden';
      exitScreen();
    },

    enterBigScreen() {
      this.bigScreenFlag = true;
      document.getElementById('bigScreen').style.visibility = 'visible';
      fullScreen();
    },

    // 时间格式化
    dateFormat() {
      var date = new Date();
      var year = date.getFullYear();

      // 在日期格式中，月份是从0开始的
      // 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05

      var month =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      let week = date.getDay(); // 星期
      let weekArr = [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
      ];
      // 拼接 时间格式处理
      return (
        year +
        '年' +
        month +
        '月' +
        day +
        '日 ' +
        hours +
        ':' +
        minutes +
        ':' +
        seconds +
        ' ' +
        weekArr[week]
      );
    },

    fold() {
      this.isCollapse = !this.isCollapse;
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    async logOut() {
      await exit().then();

      this.$root.isLogin = false;
      removeToken();
      removeLoginGarden();
      removeLoginUser();
      // clearCookie();
      this.Axios.defaults.headers['token'] = '';
      await this.$router.push('/');
    },
    // 改变主题的css文件名
    changeSkin(type) {
      // 节流防止疯狂点击
      if (change) {
        clearTimeout(change);
      }
      let change = setTimeout(() => {
        document.head
          .querySelector('#skin')
          .setAttribute('href', `/skin/${type}.css`);
      }, 100);
    },
  },

  // 挂载时间
  mounted() {
    let that = this;
    this.timer = setInterval(function () {
      that.newDate = new Date().toLocaleString();
    });
    const location = String(window.location);
    window.location =
      location.substring(
        0,
        location.indexOf('mainWindow') + 'mainWindow'.length
      ) + '/homePage';
    document.getElementById('bigScreen').style.visibility = 'hidden';

    // 使用原生js 为单个dom绑定鼠标右击事件
    let tab_top_dom = document.getElementsByClassName('el-tabs__header is-top');
    tab_top_dom[0].oncontextmenu = this.openContextMenu;

    // 监听屏幕
    window.onresize = () => {
      window.screenWidth = document.body.clientWidth;
      that.screenWidth = window.screenWidth;
    };
    if (this.$root.dataReportInitShow) {
      setTimeout(() => {
        this.menuName = '数据报表';
        this.$router.push('/mainWindow/dataReport');
      }, 2000);
    }
  },
  // 销毁时清除计时器
  beforeDestroy: function () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>
